import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const PublicLayout = ({ children }) => {
  useEffect(() => {
    // Initialize WOW.js for animations if available
    if (window.WOW) {
      new window.WOW().init();
    }

    // Handle smooth scrolling for menu links
    const pageLinks = document.querySelectorAll('.ud-menu-scroll');
    
    const handleClick = (e) => {
      e.preventDefault();
      const targetId = e.currentTarget.getAttribute('href');
      const targetElement = document.querySelector(targetId.replace('/', ''));
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };

    pageLinks.forEach((elem) => {
      elem.addEventListener('click', handleClick);
    });

    // Cleanup
    return () => {
      pageLinks.forEach((elem) => {
        elem.removeEventListener('click', handleClick);
      });
    };
  }, []);

  return (
    <div className="public-layout">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
